import React, {Component} from 'react';
import {Container} from "react-grid-system";
import _ from 'underscore';
import Group from "./MaintenantCards/Group";

class MaintenantCards extends Component {

    state = {
        groups: []
    };

    componentDidMount() {
        const groupColumn = this.props.voting.configurations.group.split("#");
        const sortColumn = this.props.voting.configurations.sort;
        const groups = {};


        this.props.voting.data.forEach(data => {
            let column = data.fields[groupColumn[0]];
            if (groupColumn.length === 2) {
                if (Array.isArray(column) && column.length > 0) {
                    column = column[0].fields[groupColumn[1]];
                }
            }
            if (!column) {
                column = "Non déterminé";
            }
            if (!(column in groups)) {
                groups[column] = [];
            }

            groups[column].push(data);
        });

        const groupsSort = [];
        _.each(groups, (group, key) => {
            group.sort((a, b) => {
                if (a.fields[sortColumn] > b.fields[sortColumn]) {
                    return 1;
                }
                if (a.fields[sortColumn] < b.fields[sortColumn]) {
                    return -1;
                }
                return 0;
            });

            groupsSort.push({key, entries: group});
        });

        groupsSort.sort((a, b) => {
            if (a.key > b.key) {
                return 1;
            }
            if (a.key < b.key) {
                return -1;
            }
            return 0;
        });

        this.setState({
            groups: groupsSort
        })
    }

    render() {
        return (
            <Container fluid={true} style={{marginTop: '30px'}}>
                {this.state.groups.map((group) => {
                    return <Group entries={group.entries} format={this.props.voting.configurations.format} name={group.key} key={group.key}/>
                })}
            </Container>
        );
    }
}

export default MaintenantCards;


// WEBPACK FOOTER //
// ./src/Components/MaintenantCards.js